/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_About_Pricing_LabelInputs */

const en_cmp_about_pricing_label = /** @type {(inputs: Cmp_About_Pricing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const id_cmp_about_pricing_label = /** @type {(inputs: Cmp_About_Pricing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Cmp_About_Pricing_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_about_pricing_label = /** @type {((inputs?: Cmp_About_Pricing_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_About_Pricing_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_about_pricing_label(inputs)
	return en_cmp_about_pricing_label(inputs)
});